import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "src/components/Common/TableContainer";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "src";
import ModalValidation from "../Forms/FormValidation/unitsTypes/ModalValidation";
import useToast from "src/components/Common/toast";

const UnitsTypes = () => {
  document.title = "Tipos de Orgãos de Estrutura - Khozi";
  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const [unitList, setunitList] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { show, ToastComponent } = useToast();
  const [successDelete, setSuccessDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState(false);
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);

  useEffect(() => {
    if (errorDelete) {
      show("Erro", "Erro ao apagar o tipo de orgão de estrutura .");
      setErrorDelete(false);
    } else if (successDelete) {
      show("Sucesso", "Tipo de orgão de estrutura apagado com sucesso.");
      setSuccessDelete(false);
    } else if (errorUpdate) {
      show("Erro", "Erro ao actualizar o tipo de orgão de estrutura.");
      setErrorUpdate(false);
    } else if (successUpdate) {
      show("Sucesso", "Tipo de orgão de estrutura actualizado com sucesso.");
      setSuccessUpdate(false);
    }
  }, [successDelete, errorDelete, successUpdate, errorUpdate]);

  const units = useSelector((state: any) => state.unitsTypes.units);

  const toggle = () => {
    setModal(!modal);
  };

  const handleRowClick = (arg: any) => {
    const unit = arg;
    setunitList({
      id: unit.id,
      name: unit.name,
      level: unit.level,
      key: unit.key,
    });
    setIsEdit(true);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Nome",
        accessor: "name",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Chave",
        accessor: "key",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Nível",
        accessor: "level",
        disableFilters: true,
        filterable: true,
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {ToastComponent}
          <Breadcrumbs
            title="Orgãos de Estrutura"
            breadcrumbItem="Tipos de Orgãos de Estrutura"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    addButtonLabel="Novo Tipo de Orgão"
                    columns={columns}
                    data={units}
                    isGlobalFilter={true}
                    isAddUserList={true}
                    customPageSize={10}
                    className="custom-header-css"
                    handleUserClick={() => {
                      navigate("/units/types/create");
                    }}
                    handleRowClick={handleRowClick}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} centered={true}>
            <ModalHeader toggle={toggle} tag="h4">
              Editar {unitList.name}
            </ModalHeader>
            <ModalBody>
              <ModalValidation
                selectedUnit={unitList}
                setModal={setModal}
                setSuccessDelete={setSuccessDelete}
                setErrorDelete={setErrorDelete}
                setSuccessUpdate={setSuccessUpdate}
                setErrorUpdate={setErrorUpdate}
              />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UnitsTypes;
